import React from 'react';
import HeroSection from './components/HeroSection';
import ContentSections from './components/ContentSections';
import './styles/styles.scss';
function AIAdLanding({ user }) {
    return (React.createElement("div", { className: "ai-ad-landing" },
        React.createElement(HeroSection, { user: user }),
        React.createElement(ContentSections, null)));
}
export default AIAdLanding;
